export const FILE_MAP = {
	loi_document: "LOI Document",
	bd_feasibility: "BD FEASIBILITY",
	floor_plan: "Floor Plan",
	facade_picture: "Facade Picture",
	landlord_scope_of_work: "Landlord Scope Of Work",
	lease_agreement: "Lease Agreement",
	business_suraksha: "Business Suraksha",
	workmen_compensation: "Workmen Compensation",
	liscence_document: "Liscence Document",
	mall_hs_presentation: "MALL / HS Presentation",
	PANCARD: "Pancard",
	GST_CERT: "GST Certificate",
	BLANK_CHEQUE_PHOTO: "Blank Cheque Photo Copy",
	salvage_quotation: "Salvage Quotation",
	renovation_quotation: "Renovation Quotation",
};
